/*
  Trail generation
*/

import axios from 'axios';
import _config from '../../config';

export default {
  init: function () {

  },
  generate: function (fromAddressLat, fromAddressLon, toAddressLat, toAddressLon, routeType, meanderCode, fromAddress, toAddress) {
    // Promise is resolved with generated route guid or null if unable to generate a route as no trees in that area.

    return new Promise(function (resolve, reject) {
      routeType = routeType || 'species20'; // default
      routeType += ':' + meanderCode; // Add the percent meander required

      // console.log('lib/generate', fromAddressLat, fromAddressLon, toAddressLat, toAddressLon, routeType, meanderCode, fromAddress, toAddress);

      var url = '/api/v2/trails/generate/' + fromAddressLat + '/' + fromAddressLon + '/type/' + routeType;
      var queryParams = 'project=' + _config.ROUTES_PROJECT;
      if (toAddressLat && toAddressLon) {
        url += '/to/' + toAddressLat + '/' + toAddressLon;
      }
      if (fromAddress) {
        queryParams += '&fromAddress=' + fromAddress;
      }
      if (toAddress) {
        queryParams += '&toAddress=' + toAddress;
        // Allow on the A2B route there to be no trees found but still generate the best route
        queryParams += '&allowZeroPOI=true';
      }

      const link = _config.getURI(url, queryParams);
      var routeGuid;

      axios.get(link)
        .then(response => {
          // console.log('response:', response);
          // response.data is the body of response
          // contains the route id of the generated route only
          routeGuid = response.data.guid;
          // console.log('new route:', routeGuid);
          resolve(routeGuid);
        })
        .catch(error => {
          // console.log('error:', error);
          if (error.response) {
            // server responded
            if (error.response.status === 404) {
              // var modalHeaderMessage = 'No trees';
              // var modalBodyMessage = 'Cannot find any suitable (identified) trees in this area. Please select a different start location which has identified trees.';
              // console.log('No trees for trail');
              resolve(null);
            } else {
              console.log('Error GE2:', error.response.status);
              reject(Error('An error occurred (GE2)'));
            }
          } else if (error.request) {
            // the request was made but no response obtained
            console.log('Error GE3:', error.request);
            reject(Error('An error occurred (GE3)'));
          } else {
            // something happened in setting up the request which triggered an error
            console.log('Error GE1:', error.message);
            reject(Error('An error occurred (GE1)'));
          }
        });
    });
  }
};
